import React from 'react';
import { Table } from 'antd';
import Typography from '../../components/Typography';
import { Medal } from '@phosphor-icons/react';
import COLORS from '../../util/constants/colors';

const TopProviders = ({ topProviders, loading }) => {
  const columns = [
    {
      title: 'PROVIDER',
      dataIndex: 'provider_name',
      key: 'provider_name',
    },
    {
      title: 'FACILITY',
      dataIndex: 'provider_office',
      key: 'provider_office',
    },
    {
      title: 'REFERRALS',
      dataIndex: 'referral_count',
      key: 'referral_count',
    },
    {
      title: 'CONVERSION RATE',
      dataIndex: 'percentage_scheduled',
      key: 'percentage_scheduled',
      render: (text) => `${text.toFixed(2)}%`,
    },
  ];

  return (
    <div className="top-providers-section">
      <Typography variant="text" size="medium" bold className="referral-trends-header">
        <Medal color={COLORS.ATTENTION_LITE} size={16} weight="bold" />
        &nbsp;
        Top Referring Providers
      </Typography>
      <Table
        className="top-providers-table"
        pagination={false}
        columns={columns}
        dataSource={topProviders}
        style={{ width: '100%', height: '100%' }}
        scroll={{ y: 250 }}
        loading={loading}
      />
    </div>
  )
};

export default TopProviders;
